import { FIELD_TYPES } from "constants/template-field-type";

export default {
  input: { type: FIELD_TYPES.TEXT, label: "Markdown content", textArea: true, rows: 15 }
};
